import { NotFoundError } from '@magicdoorinc/errors';
import { CurrentUnitUnlistedError } from '~/errors/errors';
import { companyUnitListingGateway } from '~/gateways/companyUnitListingGateway';
import { emptyRentalApplicationInfo } from '~/state/mainAppState';
import { MagicUseCase } from '~/use-cases/magicUseCase';
import { SiteRoute } from '~/use-cases/types/SiteRoute';

export class CreateRentalApplicationUseCase extends MagicUseCase<string | undefined> {
  protected async runLogic(unitId?: string) {
    if (unitId) {
      try {
        await companyUnitListingGateway.getUnitListingDetail(unitId, this.getState().user.companyInfo?.id);
      } catch (error) {
        if (error instanceof NotFoundError) {
          throw new CurrentUnitUnlistedError();
        }
        throw error;
      }
    }
    this.getState().user.rentalApplication = emptyRentalApplicationInfo();
    this.navigate(unitId ? `${SiteRoute.RentalApplicationGetStarted}?unitId=${unitId}` : SiteRoute.RentalApplicationGetStarted);
  }
}
